import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8
  },
  adminRoot: { opacity: '50%' },
  top: { padding: theme.spacing(2) },
  section: { padding: theme.spacing(1.5, 2) },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      fontWeight: 600
    }
  },
  greyText: { fontWeight: 500, color: theme.palette.grey[700] },
  darkText: {
    fontWeight: 600,
    color: theme.palette.grey[800],
    fontSize: 14,
    textAlign: 'right'
  },
  greenText: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    textAlign: 'right'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '9fr 4fr',
    gap: 4,
    marginBottom: theme.spacing(1),
    fontSize: '0.9rem'
  }
}))
